<template>
  <v-container>
    <span class="title">An online version of <a href="https://store.cardsagainsthumanity.com/">Cards Against Humanity</a>&trade;</span>
    <br>
    <p>The game assets on this site are used under the Creative Commons BY-NC-SA 2.0 license.</p>
    <p>Card texts from <a href="https://crhallberg.com/cah/">JSON Against Humanity</a></p>
    <p>This work is licensed under a <a rel="license" href="http://creativecommons.org/licenses/by-nc-sa/4.0/">Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License</a>.</p>
    <a rel="license" href="http://creativecommons.org/licenses/by-nc-sa/4.0/"><img alt="Creative Commons License" style="border-width:0" src="https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png" /></a>
    <br>
    <br>
    <br>
    <v-row align="center" justify="center">
      <v-img
        src="../assets/cartoon-cat.png"
        class="grey lighten-2"
        max-width="400"
        max-height="250"
      >
      </v-img>
    </v-row>
    <br>
    <br>
  </v-container>
</template>

<script>

export default {
  name: 'About',
  data () {
    return {
    }
  }
}
</script>
